import './index.css'

export default function BoxLegend(props: any) {
  const { title, content } = props
  return (
    <div className="box-legend">
      <legend
        className="box-legend__title"
      >
        {title}
      </legend>
      <div className="box-legend__content">{content}</div>

    </div>
  )
}